<div class="merchant-profile-page" *ngIf="merchant">

  <!-- Premium Vendor Header Card -->
  <div class="vendor-header-wrapper">
    <div class="vendor-card-header">

      <!-- Left: Image Slider/Cover -->
      <div class="vendor-image-col">
        <img
          [src]="merchant.profile_pic ? (merchant.profile_pic.startsWith('/') ? apiUrl + merchant.profile_pic : merchant.profile_pic) : (merchant.shop_photo ? (imageUrl + merchant.shop_photo) : 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=800&q=80')"
          alt="Cover Photo"
          onerror="this.src='https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=800&q=80'">
      </div>

      <!-- Right: Content -->
      <div class="vendor-content-col">

        <!-- Top Badges -->
<div class="top-actions">

   <div
    class="badge-preferred"
    *ngIf="merchant.subscriptionTier === 'PREMIUM'"
  >
    <span class="material-symbols-outlined">workspace_premium</span>
    Premium
  </div>

  <div class="action-buttons">
    <button
      type="button"
      class="btn-shortlist"
      [class.shortlisted]="isShortlisted"
      [disabled]="shortlistLoading"
      (click)="toggleShortlist($event)"
    >
      <span class="material-symbols-outlined">
        {{ isShortlisted ? 'star' : 'star_border' }}
      </span>

      {{ isShortlisted ? 'Shortlisted' : 'Shortlist' }}
    </button>
  </div>

</div>


<!-- Business Name -->
<h1 class="vendor-title">
  {{ merchant.business_name }}
</h1>


<!-- Owner Name -->
<p class="vendor-location">
  <span class="material-symbols-outlined">
    person
  </span>

  {{ merchant.owner_name }}
</p>


<!-- Category -->
<div class="delivery-tag">
  <!-- {{ merchant.category?.name || merchant.category }} -->
    {{displayCategoryName}}
</div>



<!-- Merchant Details Box -->
<div class="ratings-box">

  <div class="rating-score">

    <strong>
      {{ totalBookings || 0 }}
    </strong>

    <span>
      Bookings
    </span>

  </div>


  <div class="rating-divider"></div>


  <div class="rating-quality">

    <strong>
      {{ merchant.years_of_experience || 0 }}+
    </strong>

    <span>
      Years Experience
    </span>

  </div>

</div>



<!-- Business Description -->
<div class="business-short-description">

  {{ merchant.business_description || 'No description available' }}

</div>

        <!-- Price (if available from services) -->
        <!-- <div class="price-box" *ngIf="services.length > 0">
          <h2>₹{{ services[0].price | number }}</h2>
          <span>Starting price for {{ services[0].service_name }}</span>
        </div>
        <div class="price-box" *ngIf="services.length === 0">
          <h2>₹...</h2>
          <span>Pricing available in services</span>
        </div> -->

        <!-- Bottom Buttons -->
        <div class="bottom-actions">
          <button class="btn-enquiry" (click)="openEnquiryModal()">
            <span class="material-symbols-outlined">chat_bubble</span> Send Enquiry
          </button>
          <button class="btn-contact" (click)="openContactModal()">
            <span class="material-symbols-outlined">call</span> View Contact
          </button>
        </div>

        <!-- My Activity Buttons -->
        <div class="my-activity-row">
          <button class="btn-my-activity" (click)="openMyPanel('bookings')">
            <span class="material-symbols-outlined">event_available</span> My Bookings
          </button>
          <button class="btn-my-activity" (click)="openMyPanel('enquiries')">
            <span class="material-symbols-outlined">forum</span> My Enquiries
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- Navigation Tabs -->
  <div class="profile-tabs-wrapper">
    <div class="profile-tabs">
      <button [class.active]="activeTab === 'services'" (click)="changeTab('services')">Services <span class="badge"
          *ngIf="services.length">{{services.length}}</span></button>
      <button [class.active]="activeTab === 'about'" (click)="changeTab('about')">About</button>
      <button [class.active]="activeTab === 'portfolio'" (click)="changeTab('portfolio')">Portfolio</button>
      <button [class.active]="activeTab === 'reviews'" (click)="changeTab('reviews')">Reviews</button>
    </div>
  </div>

  <div class="profile-content-container">

    <!-- ABOUT TAB -->
    <div class="tab-pane" *ngIf="activeTab === 'about'">
      <div class="about-grid">
        <div class="about-card main-card">
          <h3>Our Story</h3>
          <p class="story-text">{{ merchantAbout?.story || 'Welcome to ' + (merchant.business_name ||
            merchant.businessName) + '. We are dedicated to providing the best services for your special day. Contact us
            to learn more about our offerings and how we can make your wedding unforgettable.' }}</p>
        </div>

        <div class="about-card side-card">
          <h3>Our Speciality</h3>
          <div class="speciality-pills">
            <ng-container *ngIf="merchantAbout?.speciality; else defaultSpeciality">
              <span class="pill" *ngFor="let item of merchantAbout.speciality.split(',')">{{ item.trim() }}</span>
            </ng-container>
            <ng-template #defaultSpeciality>
              <span class="pill">Professional Services</span>
              <span class="pill">Premium Quality</span>
              <span class="pill">Experienced Team</span>
            </ng-template>
          </div>

          <hr class="divider">

          <h3>Business Details</h3>
          <ul class="details-list">
            <li>
              <span class="material-symbols-outlined">work</span>
              <span><strong>Experience:</strong> {{ merchant.years_of_experience || '5+' }} Years</span>
            </li>
            <li>
              <span class="material-symbols-outlined">verified</span>
              <span><strong>Status:</strong> Verified Vendor</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- PORTFOLIO TAB -->
    <div class="tab-pane" *ngIf="activeTab === 'portfolio'">

      <!-- FOLDERS VIEW -->
      <div *ngIf="!selectedServiceFolder">
        <div class="empty-state" *ngIf="services.length === 0">
          <span class="material-symbols-outlined">photo_library</span>
          <h3>No Portfolio Items</h3>
          <p>This merchant hasn't uploaded any photos or videos yet.</p>
        </div>

        <div class="folders-grid" *ngIf="services.length > 0"
          style="display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 25px; padding: 20px 0;">
          <div *ngFor="let svc of services" (click)="getPortfolio(svc)" class="folder-card"
            style="border-radius: 12px; overflow: hidden; cursor: pointer; transition: transform 0.3s, box-shadow 0.3s; background: #fff; box-shadow: 0 4px 15px rgba(0,0,0,0.05); position: relative; aspect-ratio: 4/3;"
            onmouseover="this.style.transform='translateY(-5px)'; this.style.boxShadow='0 10px 25px rgba(0,0,0,0.1)'"
            onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.05)'">

            <div style="width: 100%; height: 100%; background-color: #f8f9fa;">
              <img *ngIf="svc.media && svc.media.length && svc.media[0].media_type === 'image'"
                [src]="imageUrl + svc.media[0].media_url" style="width: 100%; height: 100%; object-fit: cover;">
              <video *ngIf="svc.media && svc.media.length && svc.media[0].media_type === 'video'"
                [src]="imageUrl + svc.media[0].media_url" style="width: 100%; height: 100%; object-fit: cover;"></video>
              <div *ngIf="!svc.media || !svc.media.length"
                style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #ffebee;">
                <span class="material-symbols-outlined" style="font-size: 64px; color: #B01E3E;">photo_library</span>
              </div>
            </div>

            <div
              style="position: absolute; bottom: 0; left: 0; width: 100%; padding: 40px 20px 20px; background: linear-gradient(to top, rgba(0,0,0,0.8), transparent); color: #fff; display: flex; flex-direction: column; justify-content: flex-end; box-sizing: border-box;">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <h3
                  style="margin: 0; font-size: 18px; font-weight: 600; text-shadow: 1px 1px 3px rgba(0,0,0,0.5); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80%;">
                  {{svc.service_name}}</h3>
                <span class="material-symbols-outlined"
                  style="font-size: 18px; background: rgba(255,255,255,0.2); padding: 8px; border-radius: 50%; backdrop-filter: blur(4px);">grid_view</span>
              </div>
              <p style="margin: 5px 0 0; font-size: 13px; opacity: 0.9;">View portfolio</p>
            </div>
          </div>
        </div>
      </div>

      <!-- GALLERY VIEW -->
      <div *ngIf="selectedServiceFolder">
        <div style="margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center;">
            <button class="btn-secondary" (click)="backToFolders()"
              style="margin-right: 15px; border: 1px solid #ccc; padding: 6px 12px; border-radius: 6px; cursor: pointer; background: #fff;">
              <span class="material-symbols-outlined"
                style="vertical-align: middle; font-size: 16px; margin-right: 4px;">arrow_back</span>
              Back
            </button>
            <h3 style="margin: 0; font-size: 20px;">{{ selectedServiceFolder.service_name }} - Portfolio</h3>
          </div>
        </div>

        <div class="empty-state" *ngIf="selectedServicePortfolios.length === 0">
          <span class="material-symbols-outlined">photo_library</span>
          <h3>No Items Found</h3>
          <p>No portfolio images or videos found for this service.</p>
        </div>

        <div class="portfolio-masonry" *ngIf="selectedServicePortfolios.length > 0">
          <div class="portfolio-item" *ngFor="let item of selectedServicePortfolios" (click)="openMedia(item)">
            <div class="media-container">
              <img *ngIf="item.media_type === 'image'" [src]="imageUrl + item.media_url" alt="Portfolio Image">
              <video *ngIf="item.media_type === 'video'" [src]="imageUrl + item.media_url" muted loop
                onmouseover="this.play()" onmouseout="this.pause()"></video>

              <div class="hover-overlay">
                <span class="material-symbols-outlined">{{ item.media_type === 'video' ? 'play_circle' : 'zoom_in'
                  }}</span>
              </div>
            </div>
            <div class="item-info">
              <h4>{{ item.title || 'Portfolio Item' }}</h4>
              <span class="event-tag" *ngIf="item.event_type">{{ item.event_type }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- SERVICES TAB -->
    <div class="tab-pane" *ngIf="activeTab === 'services'">
      <div class="empty-state" *ngIf="services.length === 0">
        <span class="material-symbols-outlined">inventory_2</span>
        <h3>No Services Available</h3>
        <p>This merchant hasn't added any specific services yet.</p>
      </div>

      <div class="services-list" *ngIf="services.length > 0">
        <div class="service-card" *ngFor="let service of services">
          <div class="service-media">
            <img *ngIf="service.media?.length && service.media[0]?.media_type === 'image'"
              [src]="imageUrl + service.media[0].media_url" alt="Service Image">
            <video *ngIf="service.media?.length && service.media[0]?.media_type === 'video'"
              [src]="imageUrl + service.media[0].media_url"></video>
            <!-- Fallback image -->
            <img *ngIf="!service.media?.length"
              src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=400&q=80"
              alt="Service Image">
          </div>

          <div class="service-details">
            <div class="service-header">
              <h3>{{ service.service_name || service.name }}</h3>
              <div class="service-price">
                <span class="currency">₹</span>{{ service.price | number }}
              </div>
            </div>

            <p class="service-desc">{{ service.description }}</p>

            <div class="service-features" *ngIf="service.included?.length">
              <span class="feature" *ngFor="let inc of service.included | slice:0:3">
                <span class="material-symbols-outlined">check_circle</span> {{ inc }}
              </span>
              <span class="feature more" *ngIf="service.included.length > 3">+{{ service.included.length - 3 }}
                more</span>
            </div>

            <div class="service-actions">
              <button class="btn-secondary" (click)="viewService(service._id)">View Details</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- REVIEWS TAB -->
    <div class="tab-pane" *ngIf="activeTab === 'reviews'">
      <div class="empty-state">
        <span class="material-symbols-outlined">star_rate</span>
        <h3>No Reviews Yet</h3>
        <p>Be the first to review this merchant after your event!</p>
        <button class="btn-primary mt-3">Write a Review</button>
      </div>
    </div>

  </div>

  <!-- MEDIA VIEWER MODAL -->
  <div class="media-lightbox" *ngIf="showViewer" (click)="closeViewer()">
    <button class="btn-close" (click)="closeViewer()">
      <span class="material-symbols-outlined">close</span>
    </button>
    <div class="lightbox-content" (click)="$event.stopPropagation()">
      <div class="media-wrapper">
        <img *ngIf="selectedMedia?.media_type === 'image'" [src]="imageUrl + selectedMedia.media_url" alt="Fullscreen Image">
        <video *ngIf="selectedMedia?.media_type === 'video'" [src]="imageUrl + selectedMedia.media_url" controls autoplay></video>
      </div>
      <div class="media-caption" *ngIf="selectedMedia?.title || selectedMedia?.description">
        <h3>{{ selectedMedia.title }}</h3>
        <p>{{ selectedMedia.description }}</p>
        <div class="media-meta" *ngIf="selectedMedia.event_location || selectedMedia.event_year">
          <span *ngIf="selectedMedia.event_location"><span class="material-symbols-outlined">location_on</span> {{ selectedMedia.event_location }}</span>
          <span *ngIf="selectedMedia.event_year"><span class="material-symbols-outlined">calendar_today</span> {{ selectedMedia.event_year }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ ENQUIRY MODAL ═══ -->
  <div class="modal-overlay" *ngIf="showEnquiryModal" (click)="closeEnquiryModal()">
    <div class="modal-box" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>
          <h3>Send Enquiry</h3>
          <p>to {{ merchant?.business_name || merchant?.businessName }}</p>
        </div>
        <button class="modal-close" (click)="closeEnquiryModal()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="modal-body">
        <label>Your Message</label>
        <textarea [(ngModel)]="enquiryMessage" placeholder="Hi, I'm interested in your services for my wedding on [date]. Can you share more details about pricing and availability?" rows="5"></textarea>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeEnquiryModal()">Cancel</button>
        <button class="btn-send" (click)="submitEnquiry()" [disabled]="enquirySending">
          <span class="material-symbols-outlined spin-icon" *ngIf="enquirySending">autorenew</span>
          <span class="material-symbols-outlined" *ngIf="!enquirySending">send</span>
          {{ enquirySending ? 'Sending...' : 'Send Enquiry' }}
        </button>
      </div>
    </div>
  </div>

  <!-- ═══ CONTACT MODAL ═══ -->
  <div class="modal-overlay" *ngIf="showContactModal" (click)="closeContactModal()">
    <div class="modal-box contact-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div>
          <h3>Contact Details</h3>
          <p>{{ merchant?.business_name || merchant?.businessName }}</p>
        </div>
        <button class="modal-close" (click)="closeContactModal()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="contact-list">
        <div class="contact-item" *ngIf="merchant?.phone">
          <span class="contact-icon">
            <span class="material-symbols-outlined">call</span>
          </span>
          <div class="contact-info">
            <span class="contact-label">Phone</span>
            <span class="contact-value">{{ merchant.phone }}</span>
          </div>
          <button class="btn-copy" (click)="copyToClipboard(merchant.phone, 'Phone')">
            <span class="material-symbols-outlined">content_copy</span>
          </button>
        </div>
        <div class="contact-item" *ngIf="merchant?.email">
          <span class="contact-icon">
            <span class="material-symbols-outlined">mail</span>
          </span>
          <div class="contact-info">
            <span class="contact-label">Email</span>
            <span class="contact-value">{{ merchant.email }}</span>
          </div>
          <button class="btn-copy" (click)="copyToClipboard(merchant.email, 'Email')">
            <span class="material-symbols-outlined">content_copy</span>
          </button>
        </div>
        <div class="contact-item" *ngIf="merchant?.whatsapp">
          <span class="contact-icon" style="background:#25D366;">
            <span class="material-symbols-outlined" style="color:white">chat</span>
          </span>
          <div class="contact-info">
            <span class="contact-label">WhatsApp</span>
            <span class="contact-value">{{ merchant.whatsapp }}</span>
          </div>
          <button class="btn-copy" (click)="copyToClipboard(merchant.whatsapp, 'WhatsApp')">
            <span class="material-symbols-outlined">content_copy</span>
          </button>
        </div>
        <div class="contact-item" *ngIf="merchant?.address">
          <span class="contact-icon">
            <span class="material-symbols-outlined">location_on</span>
          </span>
          <div class="contact-info">
            <span class="contact-label">Address</span>
            <span class="contact-value">{{ merchant.address }}</span>
          </div>
          <button class="btn-copy" (click)="copyToClipboard(merchant.address, 'Address')">
            <span class="material-symbols-outlined">content_copy</span>
          </button>
        </div>
        <div class="no-contact" *ngIf="!merchant?.phone && !merchant?.email && !merchant?.whatsapp">
          <span class="material-symbols-outlined">info</span>
          Contact details not provided yet. Send an enquiry instead.
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ MY BOOKINGS / ENQUIRIES PANEL ═══ -->
  <div class="modal-overlay" *ngIf="showMyPanel" (click)="closeMyPanel()">
    <div class="modal-box my-panel" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="panel-tabs">
          <button [class.active]="myPanelTab === 'bookings'" (click)="switchPanelTab('bookings')">
            <span class="material-symbols-outlined">event_available</span> My Bookings
          </button>
          <button [class.active]="myPanelTab === 'enquiries'" (click)="switchPanelTab('enquiries')">
            <span class="material-symbols-outlined">forum</span> My Enquiries
          </button>
        </div>
        <button class="modal-close" (click)="closeMyPanel()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="panel-body">

        <!-- Loading -->
        <div class="panel-loading" *ngIf="myPanelLoading">
          <span class="material-symbols-outlined spin-icon">autorenew</span> Loading...
        </div>

        <!-- BOOKINGS TAB -->
        <div *ngIf="myPanelTab === 'bookings' && !myPanelLoading">
          <div class="panel-empty" *ngIf="myBookings.length === 0">
            <span class="material-symbols-outlined">event_note</span>
            <p>No bookings with this vendor yet.</p>
          </div>
          <div class="panel-booking-card" *ngFor="let b of myBookings">
            <div class="pb-top">
              <div>
                <strong>{{ b.service_name }}</strong>
                <span class="pb-date">{{ b.selectedDate?.day }}/{{ b.selectedDate?.month }}/{{ b.selectedDate?.year }}</span>
              </div>
              <span class="pb-status" [class.confirmed]="b.booking_status === 'Confirmed'" [class.pending]="b.booking_status === 'Pending'" [class.rejected]="b.booking_status === 'Rejected'">
                {{ b.booking_status }}
              </span>
            </div>
            <p class="pb-detail">{{ b.function_name }} · {{ b.location }} · ₹{{ b.price | number }}</p>
            <p class="pb-reject" *ngIf="b.booking_status === 'Rejected' && b.reject_reason">
              <span class="material-symbols-outlined" style="font-size:13px">info</span>
              Reason: {{ b.reject_reason }}
            </p>
          </div>
        </div>

        <!-- ENQUIRIES TAB -->
        <div *ngIf="myPanelTab === 'enquiries' && !myPanelLoading">
          <div class="panel-empty" *ngIf="myEnquiries.length === 0">
            <span class="material-symbols-outlined">forum</span>
            <p>No enquiries with this vendor yet.</p>
          </div>
          <div class="panel-enquiry-card" *ngFor="let e of myEnquiries">
            <div class="eq-row" *ngFor="let msg of e.messages" [ngClass]="{'mine': msg.sender_type === 'USER', 'reply': msg.sender_type === 'MERCHANT'}">
              <div class="eq-bubble" [ngClass]="{'reply-bubble': msg.sender_type === 'MERCHANT'}">
                <span class="eq-tag">{{ msg.sender_type === 'USER' ? 'You' : 'Vendor' }}</span>
                {{ msg.message }}
                <span class="eq-time">{{ msg.created_at | date:'d MMM, h:mm a' }}</span>
              </div>
            </div>
            <div class="eq-no-reply" *ngIf="e.messages?.length === 1">
              Awaiting reply from vendor...
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>